import { render, staticRenderFns } from "./form.vue?vue&type=template&id=3997c0fb&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3997c0fb')) {
      api.createRecord('3997c0fb', component.options)
    } else {
      api.reload('3997c0fb', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=3997c0fb&", function () {
      api.rerender('3997c0fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/plan/form.vue"
export default component.exports